import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Global } from '@services/core/Global';
import { QueryUtils } from 'app/core/utils/query.utils';

@Injectable({
  providedIn: 'root'
})
export class DocumentService {
  private http = inject(HttpClient);
  private url = Global.url;

  // Obtiene los documentos del socio de forma dedicada
  getPartyDocuments(params: any): Observable<any> {
    const queryParams = QueryUtils.convertToFilter(params);
    return this.http.get(`${this.url}V1/document-party`, { params: queryParams });
  }

  // Obtiene los documentos del vehículo de forma dedicada
  getVehicleDocuments(params: any): Observable<any> {
    const queryParams = QueryUtils.convertToFilter(params);
    return this.http.get(`${this.url}V1/document-vehicle`, { params: queryParams });
  }

  // Sube o reemplaza un archivo de documento mediante FormData
  uploadDocument(
    uuid: string,
    file: File,
    origin: 'PARTY' | 'VEHICLE' | 'CLAIM' = 'PARTY',
    extras?: { expirationDate?: string | null }
  ): Observable<any> {
    const formData = new FormData();
    formData.append('file', file);
    if (extras?.expirationDate) {
      formData.append('expirationDate', extras.expirationDate);
    }
    return this.http.put(`${this.url}V1/documents/upload/${uuid}`, formData, {
      params: { origin }
    });
  }

  // Crea un requerimiento opcional de documento para siniestros
  createDocumentClaim(payload: any): Observable<any> {
    return this.http.post(`${this.url}V1/document-claim`, payload);
  }

  // Elimina un requerimiento opcional de siniestros
  deleteDocumentClaim(uuid: string): Observable<any> {
    return this.http.delete(`${this.url}V1/document-claim/${uuid}`);
  }

  // Sube evidencia física del siniestro
  uploadClaimDocument(uuid: string, file: File): Observable<any> {
    const formData = new FormData();
    formData.append('file', file);
    return this.http.put(`${this.url}V1/documents/upload/${uuid}`, formData);
  }

  /** Metadatos del documento (mimeType, fileName, etc.). */
  getByUuid(uuid: string): Observable<any> {
    return this.http.get(`${this.url}V1/documents/${uuid}`);
  }
}
